const ReviewOptionGroup = ({
  title,
  options = [],
  selectedIds = [],
  onToggle,
  variant,
    readOnly
}) => {

  const isPositive = variant === "positive";

  return (
    <div>

      <h3 className="font-bold mb-3">{title}</h3>

      <div className="flex flex-wrap gap-2">

        {options.map((option) => {

          const selected = selectedIds.includes(option.id);

          return (
            <button
              key={option.id}
              type="button"
              disabled={readOnly}
              onClick={() => onToggle(option.id)}
              className={`px-3 py-1 rounded-full border text-sm
                ${selected
                  ? isPositive
                    ? "bg-green-100 border-green-500"
                    : "bg-red-100 border-red-500"
                  : "bg-white border-gray-300"
                }
              `}
            >
              {option.title}
            </button>
          );
        })}

      </div>

    </div>
  );
};

export default ReviewOptionGroup;
